import { render, staticRenderFns } from "./CloudWhatsapp.vue?vue&type=template&id=d334f9e4&"
import script from "./CloudWhatsapp.vue?vue&type=script&lang=js&"
export * from "./CloudWhatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d334f9e4')) {
      api.createRecord('d334f9e4', component.options)
    } else {
      api.reload('d334f9e4', component.options)
    }
    module.hot.accept("./CloudWhatsapp.vue?vue&type=template&id=d334f9e4&", function () {
      api.rerender('d334f9e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/channels/CloudWhatsapp.vue"
export default component.exports